import styled from '@emotion/styled';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import { TipCard } from 'src/modules/programs/components/TipCard';
import { Modal } from 'src/shared/components/Modal';
import { color, font, layout } from 'src/shared/styles/variables';

const StyledModal = styled(Modal)({
    '& .ant-modal-body': {
        padding: '4rem',
        maxWidth: layout.modalWidth.wide,
    },
    '& h4': {
        ...font.heavy(font.size.large),
        color: color.bayOfMany,
    },
    '& p': {
        ...font.book(font.size.large),
        color: color.tundora,
        margin: '0 0 2rem',
        lineHeight: 1.7,
    },
    '& ul': {
        marginLeft: 0,
        listStyleType: 'none',
        margin: '0 0 2rem',
        paddingLeft: 0,

        '& > li': {
            ...font.book(font.size.large),
            position: 'relative',
            lineHeight: '1.5',
            '&:not(:last-child)': {
                marginBottom: '0.75rem',
            },
        },
    },
});

interface ModalIconProps {
    iconUrl: string;
}

const ModalIcon = styled('i')((props: ModalIconProps) => ({
    display: 'block',
    backgroundImage: `url(${props.iconUrl})`,
    height: '12rem',
    width: '12rem',
    margin: '2rem auto',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
}));

const ModalTitle = styled('h3')(
    {
        width: '100%',
        margin: '0 0 2rem',
        color: color.bayOfMany,
        textAlign: 'center',
    },
    font.heavy(font.size.header),
);

interface Props {
    title: string;
    iconUrl: string;
    content: string;
}

interface State {
    isOpen: boolean;
}

export class MindfulnessFAQCard extends React.Component<Props, State> {
    public state: State = {
        isOpen: false,
    };

    public handleToggleModal = () => {
        this.setState(state => ({ isOpen: !state.isOpen }));
    };

    public render(): JSX.Element {
        const { iconUrl, title, content } = this.props;

        return (
            <>
                <TipCard
                    onClick={this.handleToggleModal}
                    iconUrl={iconUrl}
                    title={title}
                    centered
                />
                <StyledModal
                    visible={this.state.isOpen}
                    onCancel={this.handleToggleModal}
                    footer={null}
                    centered
                    width="auto"
                >
                    <ModalIcon iconUrl={iconUrl} />
                    <ModalTitle>{title}</ModalTitle>
                    <ReactMarkdown children={content} />
                </StyledModal>
            </>
        );
    }
}
